// 统一合并为完整的 Locale
var locale = {
  lang: {
    reset: '重置',
    search: '筛选',
    expand: '展开',
    collapse: '收起'
  }
};
export default locale;